module.exports = __webpack_public_path__ + "img/015-ticket.c029caae.svg";